import { Component, inject, Input, OnInit } from '@angular/core';
import { MENU } from '../../constants/menu';
import { RouterLink } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { BACKOFFICE_MENU } from '../../constants/backoffice-menu';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HeaderSignalService } from '../../services/header-signal.service';

@Component({
    selector: 'mobilize-main-menu',
    imports: [
        RouterLink
    ],
    animations: [
        trigger('slideToggle', [
            state('open', style({
                height: '*',
                opacity: 1,
                overflow: 'hidden'
            })),
            state('closed', style({
                height: '0px',
                opacity: 0,
                overflow: 'hidden'
            })),
            transition('open <=> closed', [
                animate('300ms ease-in-out')
            ])
        ]),
        trigger('rotateChevron', [
            state('default', style({ transform: 'rotate(0deg)' })),
            state('rotated', style({ transform: 'rotate(180deg)' })),
            transition('default <=> rotated', animate('300ms ease-in-out')),
        ])
    ],
    templateUrl: './main-menu.component.html',
    styleUrl: './main-menu.component.scss'
})
export class MainMenuComponent implements OnInit{

    @Input() backOffice!: boolean;
    @Input() impersonated!: boolean;

    private _kc = inject(KeycloakService);
    private _headerSignalService = inject(HeaderSignalService); // Injecting the signal service


    menu!: any;
    isOpen = false;

    ngOnInit() {
        this.menu = this.backOffice ? BACKOFFICE_MENU : MENU;
        if (this.impersonated) {
            this.menu = this.menu.filter((item: any) => item.route !== 'account-settings' && item.route !== '/pay' && item.route.indexOf('/my-requests') === -1);
            this.menu.forEach((item: any) => {
                if (item.route === '/existing-documents') {
                    item.route = '/generate-document'
                }
            })
        }
    }

    closeMenu() {
        this._headerSignalService.emitEvent('menuClose');
    }

    logout() {
        this._kc.logout();
    }

    toggleMenu() {
        this.isOpen = !this.isOpen;
    }
}
